import apiClient from '../../../shared/services/apiHelper';
import {
  setAuthToken,
  setUserData,
  clearAuthData
} from '../../../shared/utils/authStorage';
import { validateResponse } from '../../../shared/utils/responseHelper';

export const authService = {
  /**
   * Send OTP to phone number
   * @param {string} phoneNumber - User's phone number
   * @returns {Promise} - OTP send response
   */
  sendOTP: async (phoneNumber) => {
    try {
      const response = await apiClient.post('/auth/otp', {
        mobile: phoneNumber
      });
      return validateResponse(response, 'Failed to send OTP');
    } catch (error) {
      console.error('Error sending OTP:', error);
      throw error;
    }
  },

  /**
   * Verify OTP and authenticate user
   * @param {string} phoneNumber - User's phone number
   * @param {string} otp - OTP code
   * @returns {Promise} - Authentication response with token
   */
  verifyOTP: async (phoneNumber, otp) => {
    try {
      const response = await apiClient.post(
        '/auth/user-auth',
        {
          phone_number: phoneNumber,
          otp: otp
        },
        null, // queryParameters
      );
      const data = validateResponse(response, 'Failed to verify OTP');

      return data;
    } catch (error) {
      console.error('Error verifying OTP:', error);
      throw error;
    }
  },

  /**
   * Logout user
   * @returns {Promise} - Logout response
   */
  logout: async () => {
    try {
      // If you have a logout endpoint, uncomment and use it
      // const response = await apiClient.post('/auth/logout');
      clearAuthData();

      return { success: true, message: 'Logged out successfully' };
    } catch (error) {
      console.error('Error during logout:', error);
      clearAuthData();
      throw error;
    }
  }
};